import {
  Wand2, Sparkles, Eye, Lightbulb, Flame, BarChart3, Zap, Frown,
  BookOpen, Brain, Target, Globe, GraduationCap, Shield,
} from "lucide-react";
import theme from "../../styles/theme";

// ── Wizard Hat SVG ───────────────────────────────────────────────────────────
export const WizardHatIcon = ({ size = 24, color = theme.colors.purple }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <path d="M32 4L12 48h40L32 4z" fill={color} opacity="0.9" />
    <path d="M32 4L12 48h40L32 4z" fill="url(#hatGrad)" />
    <ellipse cx="32" cy="48" rx="26" ry="6" fill={color} opacity="0.7" />
    <ellipse cx="32" cy="48" rx="26" ry="6" fill="url(#brimGrad)" />
    <path d="M28 20l2-3 3 1 2-4 2 3 3-1 1 4" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round" opacity="0.8" />
    <circle cx="30" cy="30" r="1.5" fill="#fbbf24" opacity="0.6" />
    <circle cx="35" cy="36" r="1" fill="#fbbf24" opacity="0.5" />
    <circle cx="27" cy="38" r="1.2" fill="#fbbf24" opacity="0.4" />
    <defs>
      <linearGradient id="hatGrad" x1="12" y1="48" x2="32" y2="4">
        <stop offset="0%" stopColor="#312e81" stopOpacity="0.5" />
        <stop offset="100%" stopColor="#a78bfa" stopOpacity="0.3" />
      </linearGradient>
      <linearGradient id="brimGrad" x1="6" y1="48" x2="58" y2="48">
        <stop offset="0%" stopColor="#312e81" stopOpacity="0.3" />
        <stop offset="50%" stopColor="#7c3aed" stopOpacity="0.2" />
        <stop offset="100%" stopColor="#312e81" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

// ── Anonymous User Generator ─────────────────────────────────────────────────
const ANON_ICONS = [Wand2, Eye, Brain, Shield, BookOpen, Target, Zap, Globe, Sparkles, GraduationCap];
const ANON_COLORS = [
  theme.colors.violet, theme.colors.blue, theme.colors.green,
  theme.colors.accent, theme.colors.pink, theme.colors.cyan,
  "#c084fc", theme.colors.orange, theme.colors.teal, theme.colors.fuchsia,
];
const ANON_NAMES = [
  "Anonymous Wizard", "Shadow Scholar", "Midnight Mentor", "Phantom Prof",
  "Arcane Analyst", "Silent Sage", "Cloaked Educator", "Veiled Voice",
  "Unknown Alchemist", "Ghost Grader", "Stealth Teacher", "Mystic Mind",
];

export function getAnonIdentity(seed) {
  const idx = Math.abs(
    String(seed).split("").reduce((a, c) => a + c.charCodeAt(0), 0)
  );
  return {
    Icon: ANON_ICONS[idx % ANON_ICONS.length],
    color: ANON_COLORS[idx % ANON_COLORS.length],
    name: ANON_NAMES[idx % ANON_NAMES.length],
  };
}

// ── Reaction Definitions ─────────────────────────────────────────────────────
export const REACTIONS = [
  { key: "wise", icon: Wand2, label: "Wise", color: "#a78bfa" },
  { key: "insightful", icon: Lightbulb, label: "Insightful", color: "#fbbf24" },
  { key: "fire", icon: Flame, label: "Fire", color: "#ef4444" },
  { key: "data", icon: BarChart3, label: "Data", color: "#60a5fa" },
  { key: "strong", icon: Zap, label: "Strong", color: "#4ade80" },
  { key: "frustrated", icon: Frown, label: "Frustrated", color: "#f97316" },
];

// ── Time Helpers ─────────────────────────────────────────────────────────────
export function timeSince(ts) {
  const days = Math.floor((new Date() - new Date(ts)) / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return `${days}d ago`;
  return new Date(ts).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
